import {
  DropDown,
  Flex,
  FormControls,
  TextField,
} from '@elementary/common-ui/components';
import { Typography } from '@mui/material';
import { Controller, UseFormReturn } from 'react-hook-form';
import { AddTestForm } from 'shared/types';
import TrainingPeriodInfoTooltip from 'shared/components/TrainingPeriodInfoTooltip';
import { validateTrainingPeriodCount } from 'shared/utils/validators';
import { trainingPeriodOptions } from 'shared/constants';

type Props = {
  methods: UseFormReturn<AddTestForm, any, undefined>;
};

const WizardTrainingPeriodSection = ({ methods }: Props) => (
  <FormControls.FieldsWrapper style={{ gap: '8px' }}>
    <Flex sx={{ alignItems: 'center', gap: '4px' }}>
      <FormControls.FormTitle>Training period</FormControls.FormTitle>
      <TrainingPeriodInfoTooltip />
    </Flex>
    <FormControls.Row
      style={{ gap: '8px', flexWrap: 'wrap', alignItems: 'center' }}
    >
      <Typography component="span">Base the model on the previous</Typography>
      <TextField
        sx={{ width: '50px', minWidth: '50px' }}
        error={!!methods.formState.errors.anomalyConfig?.trainingPeriod?.count}
        {...methods.register('anomalyConfig.trainingPeriod.count', {
          valueAsNumber: true,
          validate: (value) =>
            validateTrainingPeriodCount(
              value,
              methods.getValues('anomalyConfig.trainingPeriod.period'),
            ),
        })}
      />
      <Controller
        control={methods.control}
        name="anomalyConfig.trainingPeriod.period"
        render={({ field }) => (
          <DropDown
            sortOptions={false}
            options={trainingPeriodOptions}
            sx={{ minWidth: '120px' }}
            {...field}
            onChange={(val) => {
              field.onChange(val);
              methods.trigger('anomalyConfig.trainingPeriod.count');
            }}
          />
        )}
      />
    </FormControls.Row>
  </FormControls.FieldsWrapper>
);

export default WizardTrainingPeriodSection;
